import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import deliveryService from "../services/deliveryNoteService";
import { update } from "lodash";
const initialState = {
    list: [],
    totals: null,
    lastSavedDelivery: null,
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 6, // Size of each page
};

const deliverySlice = createModule({
    name: 'deliveryNotes',
    initialState,
    reducers: {
        generatePdfRequest: (state) => {
            state.loading = true;
        },
        list: (state) => {
            state.loading = true;
        },
        listImpayes: (state) => {
            state.loading = true;
        },
        listImpayesComptoir: (state) => {
            state.loading = true;
        },
        annulerBL: (state) => {
            state.loading = true;
        },

        resetBL: (state) => {
            state.loading = true;
        },

        listComptoire: (state) => {
            state.loading = true;
        },
        listBLRetour: (state) => {
            state.loading = true;
        },
        totals: (state) => {
            state.loading = true;
        },
        filter: (state, action) => {
            state.loading = true;
        },
        add: (state) => {
            state.loading = true;
        },
        addBL: (state) => {
            state.loading = true;
        },
        update: (state) => {
            state.loading = true;
        },
        uploadBLs: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },
        lastSaved: (state) => {
            state.loading = true;
        },
        findByReference: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload.body?.content || payload.body;
            state.totalElements = payload.body.totalElements;
            state.totalPages = payload.body.totalPages;
            state.pageNumber = payload.body.pageNumber;
        },

        fetchedDataImpaye: (state, payload) => {
            state.loading = false;
            state.list = payload.body;
        },
        fetchedTotals: (state, payload) => {
            console.log(payload)
            state.loading = false;
            state.totals = payload.body ?? payload;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        deleteSuccess: (state, action) => {
            state.loading = false;
            state.deliveryNotes = state.deliveryNotes.filter(deliv => deliv.id !== action.id);
        },
        deleteFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        fetchLastSavedRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchLastSavedSuccess: (state, action) => {
            state.lastSavedDelivery = action.payload;
            state.loading = false;
        },
        fetchLastSavedFailure: (state, action) => {
            state.error = action;
            state.loading = false;
        },
    },
    sagas: (A) => ({

        *[A.list]({ payload }) {
            try {
                const data = yield call(deliveryService.list, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    payload.onSuccess(data);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload?.onError) {
                    payload.onError(e);
                }
            }
        },
        *[A.listComptoire]({ payload }) {
            try {
                const data = yield call(deliveryService.listComptoire, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listBLRetour]({ payload }) {
            try {
                const data = yield call(deliveryService.listBLRetour, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.totals]({ payload }) {
            try {
                const data = yield call(deliveryService.totals, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedTotals(data));
                if (payload.onSuccess) {
                    payload.onSuccess(data);
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listImpayes]({ payload }) {
            try {
                const data = yield call(deliveryService.listImpayes, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedDataImpaye(data));
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listImpayesComptoir]({ payload }) {
            try {
                const data = yield call(deliveryService.listImpayesComptoir, payload);
                yield put(A.finishFetching());
                console.log(data)
                yield put(A.fetchedData(data));
                if (payload.onSuccess) {
                    payload.onSuccess();
                }
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.annulerBL]({ payload }) {
            try {
                const { data } = yield call(deliveryService.annulerBL, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },

        *[A.resetBL]({ payload }) {
            try {
                const { data } = yield call(deliveryService.resetBL, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },

        *[A.uploadBLs]({ payload }) {
            try {
                yield call(deliveryService.uploadBLs, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.filter]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(deliveryService.filter, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.add]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(deliveryService.add, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
                //yield put(A.generatePdfRequest(data.data.body)); // Dispatch the action to generate the PDF after invoice creation
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addBL]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(deliveryService.addBL, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.update]({ payload }) {
            try {
                const { data } = yield call(deliveryService.update, payload.id, payload.data);
                yield put(A.finishFetching());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.setError(error.message));
            }
        },

        *[A.generatePdfRequest]({ payload }) {
            try {
                const pdfData = yield call(deliveryService.generatePdf, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.delete]({ payload }) {
            try {
                yield call(deliveryService.delete, payload.id);
                yield put(A.deleteSuccess(payload));
                payload.onSuccess();
            } catch (e) {
                console.log(e);
                yield put(A.deleteFailure(e.message));
            }
        },
        *[A.lastSaved]({ payload }) {
            try {
                const { data } = yield call(deliveryService.getLastSaved);
                if (data.body) {
                    yield put(A.fetchLastSavedSuccess(data.body));
                    if (payload.onSuccess) {
                        payload.onSuccess(data.body);
                    }
                } else {
                    yield put(A.fetchLastSavedFailure('No data found'));
                    if (payload.onError) {
                        payload.onError('No data found');
                    }
                }
            } catch (error) {
                yield put(A.fetchLastSavedFailure(error.message));
                if (payload.onError) {
                    payload.onError(error.message);
                }
            }
        },

        *[A.findByReference]({ payload }) {
            try {
                if (!payload?.reference) {
                    throw new Error("Reference is required");
                }

                const data = yield call(deliveryService.findByReference, payload.reference);
                yield put(A.finishFetching());
                console.log(data)
                if (payload?.onSuccess) {
                    payload.onSuccess(data);
                }
                return data;
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError(error.message));
                if (payload?.onError) {
                    payload.onError(error.message);
                }
            }
        },
    }),

});

export default deliverySlice;
export const deliveryActions = deliverySlice.actions;
